
// export const BASE_URL="https://aelitez.niranthra.com/api/"
export const BASE_URL="http://127.0.0.1:8000/api/"


export const LISTS={
    LAYDYWEAR_CATEGORIES:[
                {Name:"Maternity Wear",Slug:"Maternity Wear",Code:"Maternity",Id:"2",imageUrl:require("../../assets/Images/collections/2.jpg")},

        {Name:"Lounge Wear",Slug:"Lounge Wear",Code:"Lounge Wear",Id:"1",imageUrl:require("../../assets/Images/collections/1.jpg")},
        {Name:"Palazzo Pants",Slug:"Palazzo Pants",Code:"Palazzo Pants",Id:"3",imageUrl:require("../../assets/Images/collections/3.jpg")},
        {Name:"Co-ord Set",Slug:"cCo-ord Set",Code:"Co-ord Set",Id:"4",imageUrl:require("../../assets/Images/collections/4.jpg")},
        {Name:"Jeggings",Slug:"Jeggings",Code:"Jeggings",Id:"5",imageUrl:require("../../assets/Images/collections/5.jpg")},
        {Name:"Casual Wear",Slug:"Casual Wear",Code:"Casual Wear",Id:"6",imageUrl:require("../../assets/Images/collections/6.jpg")},
        // {Name:"Ethnic Wear",Slug:"EthnicWear",Code:"Ethnic Wear",Id:"7",imageUrl:require("../../assets/Images/collections/7.jpg")},
        // {Name:"Party Wear",Slug:"PartyWear",Code:"Party Wear",Id:"8",imageUrl:require("../../assets/Images/collections/8.png")},
        {Name:"Kurthis",Slug:"Kurthi",Code:"Kurthis",Id:"9",imageUrl:require("../../assets/Images/collections/7.jpg")},
    ],
    KIDSWEAR_CATEGORIES:[
        {Name:"Shorts",Slug:"Shorts",Code:"Shorts",Id:"10"},
        {Name:"Jhabla",Slug:"Jhabla",Code:"Jhabla",Id:"11"},
        {Name:"Girl Forcks",Slug:"GirlForcks",Code:"Girl Forcks",Id:"12"},
    ],
    STANDARD_COLORS:[
        {Name:"Red",Code:"Red",Id:"Red",ColorCode:"#db4444"},
        {Name:"Blue",Code:"Blue",Id:"Blue",ColorCode:"#0000FF"},
        {Name:"Green",Code:"Green",Id:"Green",ColorCode:"#44cf6c"},
        {Name:"Yellow",Code:"Yellow",Id:"Yellow",ColorCode:"#ecb018"},
        {Name:"Black",Code:"Black",Id:"Black",ColorCode:"#000000"},
        {Name:"White",Code:"White",Id:"White",ColorCode:"#fffefdff"},
        {Name:"Gray",Code:"Gray",Id:"Gray",ColorCode:"#808080"},
        {Name:"Orange",Code:"Orange",Id:"Orange",ColorCode:"#FFA500"},
        {Name:"Purple",Code:"Purple",Id:"Purple",ColorCode:"#8684d4"},
        {Name:"Pink",Code:"Pink",Id:"Pink",ColorCode:"#F4C5BF"},
        {Name:"Brown",Code:"Brown",Id:"Brown",ColorCode:"#964B00"},
        {Name:"Beige",Code:"Beige",Id:"Beige",ColorCode:"#F5F5DC"},
    ]
}

export const CONFIG={
    DATA_TYPES:{
        TextField:"text",
        NumberField:"number",
        DateField:"date",
        DateTimeField:"datetime",
        TimeField:"time",
        Dropdown:"select",
        DbDropdown:"dbselect",
        CustomDropdown:"CustomDropdown",
        Hidden:"hidden",
        Checkbox:"checkbox",
        Reference:"Reference",
        DisplayText:"DisplayText",
        DisplayDate:"DisplayDate",
        AmountField:"AmountField",
    },
    
    TABLE_DATATYPES:{
        TextField:"text",
        NumberField:"number",
        DateField:"date",
        Dropdown:"select",
        DbDropdown:"dbselect",
        CustomDropdown:"CustomDropdown",
        Hidden:"hidden",
        Checkbox:"checkbox",
        Reference:"Reference",
        Button:"Button",
        ButtonActive:"ButtonActive",
        Status:"Status",
        InputAmountField:"InputAmountField",
        InputTextField:"InputTextField",
        Image:"Image",
    },
}

export const Permissions={
    ADMIN_MENU:"ADMIN_MENU",
}

export const Roles={}

